import { render, staticRenderFns } from "./SearchTabMessages.vue?vue&type=template&id=4627cd27&scoped=true&"
import script from "./SearchTabMessages.vue?vue&type=script&lang=js&"
export * from "./SearchTabMessages.vue?vue&type=script&lang=js&"
import style0 from "./SearchTabMessages.vue?vue&type=style&index=0&id=4627cd27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4627cd27",
  null
  
)

export default component.exports